import { createContext, PropsWithChildren, useContext } from 'react';
import { useClaimResolutionTypeProvider } from './useClaimResolutionTypeProvider';

type ClaimResolutionNameData = ReturnType<typeof useClaimResolutionTypeProvider>;

const ClaimResolutionNameContext = createContext({} as ClaimResolutionNameData);

export const ClaimResolutionTypeProvider = ({ children }: PropsWithChildren<{}>) => {
  const data = useClaimResolutionTypeProvider();

  return (
    <ClaimResolutionNameContext.Provider value={data}>
      {children}
    </ClaimResolutionNameContext.Provider>
  );
};

export const useClaimResolutionTypeContext = () =>
  useContext(ClaimResolutionNameContext);
